import React, { useState } from "react";
import { Switch, Button, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import "./styles/Settings.css";

const Settings = () => {
  // ✅ PRESERVED: All AFC state management (no changes)
  const [user, setUser] = useState({
    name: "John Doe",
    email: "johndoe@example.com",
    notifications: true,
  });

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // ✅ PRESERVED: All AFC handlers (no changes)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleToggleNotifications = () => {
    setUser((prevUser) => ({ ...prevUser, notifications: !prevUser.notifications }));
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword && newPassword.length > 5) {
      alert("Password updated successfully! (This is a placeholder)");
      setNewPassword("");
      setConfirmPassword("");
    } else {
      alert("Passwords do not match or are too short!");
    }
  };


  // ✅ VISUAL UPDATE: MEO structure with scoped classes
  return (
    <div className="afc-settings dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="dashboard-header">
          <h2 className="dashboard-logo">Settings</h2>
        </div>
        <div className="dashboard-content settings-page">
          <h3 className="settings-title">Application Settings</h3>
          <p>Customize your preferences below:</p>
          <div className="settings-options">
            {/* Enable Email Notifications */}
            <div className="settings-item">
              <span>
                Enable Email Notifications{" "}
                <Tooltip title="Receive email updates for campaigns">
                  <InfoCircleOutlined />
                </Tooltip>
              </span>
              <Switch checked={user.notifications} onChange={handleToggleNotifications} />
            </div>

            {/* Profile Settings */}
            <div className="settings-item">
              <span>
                Profile Name{" "}
                <Tooltip title="Update your display name">
                  <InfoCircleOutlined />
                </Tooltip>
              </span>
              <input
                type="text"
                name="name"
                value={user.name}
                onChange={handleInputChange}
                className="settings-input"
              />
            </div>

            <div className="settings-item">
              <span>
                Email Address{" "}
                <Tooltip title="Update your email">
                  <InfoCircleOutlined />
                </Tooltip>
              </span>
              <input
                type="email"
                name="email"
                value={user.email}
                onChange={handleInputChange}
                className="settings-input"
              />
            </div>

          {/* Password Change Section */}
          <div className="settings-item password-section">
            <span>
              Change Password{" "}
              <Tooltip title="Update your account password">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
            <div className="password-inputs">
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="settings-input"
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="settings-input"
              />
            </div>
          </div>

          {/* Update Password Button (renamed from Save Changes) */}
          <Button 
            className="save-settings-btn" 
            onClick={handlePasswordChange}
          >
            Update Password
          </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;